import { render, staticRenderFns } from "./EquipamentoModal.vue?vue&type=template&id=dbbfe436&scoped=true"
import script from "./EquipamentoModal.vue?vue&type=script&lang=js"
export * from "./EquipamentoModal.vue?vue&type=script&lang=js"
import style0 from "./EquipamentoModal.vue?vue&type=style&index=0&id=dbbfe436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbfe436",
  null
  
)

export default component.exports